<template>
<v-dialog v-model="dialog"
					fullscreen
					hide-overlay
					transition="dialog-bottom-transition">
	<template v-slot:activator="{ on, attrs }">
		<v-btn class="px-5"
					 color="primary"
					 :block="block"
					 dark
					 v-bind="attrs"
					 v-on="on"
					 :class="css"
					 :small="small">
			{{label}}
		</v-btn>
	</template>
	<v-card>
		<v-toolbar dark
							 color="primary">
			<v-btn icon
						 dark
						 @click="dialog = false">
				<v-icon>mdi-close</v-icon>
			</v-btn>
			<b class="text-h6"> Transfert de {{asset_code}} </b>

		</v-toolbar>

		<v-row class="mx-1 mt-2">

			<v-col cols=12>
				<v-card color="green darken-4"
								dark>
					<v-card-title>
						<span class="text-h6  t font-weight-light"> <b class="primary px-4 mt-n6 text-h5"
								 v-html="monetary_aspect(asset_balance)" /> {{ asset_code}} </span>

						<v-spacer></v-spacer> <span class="body-1 green mt-n8 mr-n3 px-3"> {{ ( parseInt(asset_limit) > 1000000) ? '∞' : parseInt(asset_limit)}}</span>
					</v-card-title>
					<v-card-subtitle>
						by {{ account_name(asset_issuer,false)}}
					</v-card-subtitle>
				</v-card>
			</v-col>

			<v-col cols=12>
				<v-card elevation=0>

					<listbalance :unit_only=true
											 :short=true
											 color="green darken-2"
											 filter="XLM"
											 :show_nft=false
											 ref="balance"
											 label="Choix du token de réception"
											 :select_key="distributor_account"
											 @click_asset="click_asset" />

					<div class="ma-3 pt-6">
						<v-text-field class="my-5"
													v-model="envoi_maximum"
													:label="'envoi maximum de '+ asset_code"></v-text-field>
						<v-text-field class="my-5"
													v-model="amount"
													:label="'garantie de reception de '+asset_code_fceuro"></v-text-field>

						<v-dialog transition="dialog-bottom-transition"
											v-model="dialog2"
											max-width="600">
							<template v-slot:activator="{ on, attrs }">
								<v-icon v-bind="attrs"
												large
												class="mt-3"
												style="float:right; border:1px solid gray; border-radius:2px;"
												v-on="on">
									mdi-qrcode
								</v-icon>
							</template>
							<v-card>
								<v-toolbar color="primary"
													 dark>Scanner le QR Code</v-toolbar>
								<v-card-text>
									<p class="error">{{ error }}</p>
									<qrcode-stream @decode="onDecode"
																 @init="onInit" />
								</v-card-text>
								<v-card-actions class="justify-end">
									<v-btn icon
												 @click="dialog2 = false">
										<v-icon>mdi-close</v-icon>
									</v-btn>
								</v-card-actions>
							</v-card>
						</v-dialog>


						<v-text-field class="my-5"
													required
													v-model="from"
													label="Clé publique du destinataire"
													:hint="account_name(from,false)"
													persistent-hint></v-text-field>

					</div>
				</v-card>

				<v-card v-if='asset_code ==undefined'>
					<v-card-title class="red white--text"> Vous devez sélectionner un token avant de cliquer sur le formulaire. </v-card-title>
				</v-card>

				<v-card elevation="0"
								v-if='asset_code !=undefined'>

					<v-card-text>
						<b>Paiement avec garantie de réception:</b>
						<br />

						Envoyer <b class="red--text"
							 v-html="monetary_aspect(envoi_maximum)"> </b> <code>{{asset_code}}</code> maximum
						<br />
						Reception de <b class="red--text"
							 v-html="monetary_aspect(amount)"> </b> <code>{{asset_code_fceuro}}</code>

					</v-card-text>

				</v-card>

				<validbutton :etat_transaction="etat_transaction"
										 :error_why="error_why"
										 :progress="progress"
										 @valid="send_transaction" />
			</v-col>

		</v-row>
	</v-card>
</v-dialog>
</template>


<script>
import listbalance from "@/components/stellar_list_balance.vue";
import validbutton from '@/components/valid_button.vue'
import {
	QrcodeStream,
	QrcodeDropZone,
	QrcodeCapture
} from 'vue-qrcode-reader'

var StellarSdk = require('stellar-sdk');


export default {
	name: 'stellar_payment_strict_receive',
	components: {
		QrcodeStream,
		QrcodeDropZone,
		QrcodeCapture,
		listbalance,
		validbutton
	},
	props: {

		css: String,
		small: String,

		label: {
			type: String,
			default: ""
		},

		asset_code: String,
		asset_issuer: String,
		asset_balance: String,
		asset_limit: String,

		block: {
			type: Boolean,
			default: false
		}


	},
	data: () => ({
		label_secret: "Saisir votre clé secréte",
		error: '',
		dialog2: false,
		asset_issuer_fceuro: "",
		asset_type_fceuro: "",
		asset_balance_fceuro: "",
		secret_key: "",
		etat_transaction: undefined,
		error_data: undefined,
		asset_limit_fceuro: "99999999999",
		error_why: undefined,
		transaction: undefined,
		progress: false,
		asset_code_fceuro: "fcEURO", // modifié par la suite ne pas être mis dans computed
		amount: '1',
		envoi_maximum: "1",
		dialog: false,
		from: undefined,
		etat_transaction: undefined,
		identity: undefined,
		otp: "",
	}),
	beforeCreate: function () {},
	created: function () {},
	beforeMount: function () {},
	mounted: function () {
		this.asset_balance_fceuro = this.$store.state.solde_fceuro;
		this.asset_issuer_fceuro = this.$store.getters.master_account;

	},
	beforeUpdate: function () {},
	updated: function () {},
	beforeDestroy: function () {},
	destroyed: function () {},
	computed: {
		blockchain() {
			return this.$store.state.blockchain
		},

		distributor_account() {
			return this.$store.getters.distributor_account
		},

		pin() {
			return this.$store.state.pin
		},
		privatekey() {
			return this.$store.state.privatekey
		},

	},
	methods: {
		onFinish() {
			if (this.pin == this.hash_key(this.otp)) this.secret_key = this.decrypt_key(this.otp);

		},
		onDecode(result) {
			this.from = result
			this.dialog2 = false
		},

		async onInit(promise) {
			try {
				await promise
			} catch (error) {
				if (error.name === 'NotAllowedError') {
					this.error = "ERROR: Pas de permission pour la caméra"
				} else if (error.name === 'NotFoundError') {
					this.error = "ERROR: Pas de caméra"
				} else if (error.name === 'NotSupportedError') {
					this.error = "ERROR: secure context required (HTTPS, localhost)"
				} else if (error.name === 'NotReadableError') {
					this.error = "ERROR: La caméra semble déjà en cours d'utilisation"
				} else if (error.name === 'OverconstrainedError') {
					this.error = "ERROR: installed cameras are not suitable"
				} else if (error.name === 'StreamApiNotSupportedError') {
					this.error = "ERROR: Stream API is not supported in this browser"
				} else if (error.name === 'InsecureContextError') {
					this.error = 'ERROR: Camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.';
				} else {
					this.error = `ERROR: Camera error (${error.name})`;
				}
			}

		},


		click_asset(item) {
			this.asset_code_fceuro = item.asset_code
			this.asset_issuer_fceuro_key = item.asset_issuer
			if (item.asset_type == "native") this.asset_code_fceuro = "XLM";
			this.asset_type_fceuro = item.asset_type;
			this.asset_balance_fceuro = item.balance;
			this.asset_limit_fceuro = item.limit;
		},
		send_transaction: function (key) {
			this.secret_key = key;
			this.progress = true;
			this.etat_transaction = "";

			try {
				// --------- INITIAlISATION

				if (this.blockchain == "test") {
					var server = new StellarSdk.Server("https://horizon-testnet.stellar.org");
					var net_pass = StellarSdk.Networks.TESTNET;
				}

				if (this.blockchain == "public") {
					var server = new StellarSdk.Server("https://horizon.stellar.org");
					var net_pass = StellarSdk.Networks.PUBLIC;
				}


				// ---------- CREATION DES CLES

				var sign_keys = StellarSdk.Keypair.fromSecret(this.secret_key);

				var asset_issuer_key = StellarSdk.Keypair.fromPublicKey(this.asset_issuer);

				var asset_issuer_fceuro_key = StellarSdk.Keypair.fromPublicKey(this.asset_issuer_fceuro);



				const sendAsset = new StellarSdk.Asset(this.asset_code, asset_issuer_key.publicKey())
				const destAsset = new StellarSdk.Asset(this.asset_code_fceuro, asset_issuer_fceuro_key.publicKey())
				const destAmount = this.amount;
				const sendMax = this.envoi_maximum
				const destination = this.from;
				// ---------- PARAMETRE DE LA TRANSACTION

				// ---------- SECURITE

				this.secret_key = "";

				// --------- TRANSACTION


				server
					.loadAccount(sign_keys.publicKey())
					.then(function (receiver) {
						var transaction = new StellarSdk.TransactionBuilder(receiver, {
								fee: StellarSdk.BASE_FEE,
								networkPassphrase: net_pass,
							})
							.addOperation(
								StellarSdk.Operation.pathPaymentStrictReceive({
									sendAsset: sendAsset,
									destAmount: destAmount,

									destination: destination,
									destAsset: destAsset,
									sendMax: sendMax
								}),
							)
							.setTimeout(100)
							.build();
						transaction.sign(sign_keys);
						return server.submitTransaction(transaction);
					})
					.then(response => {
						if (response != undefined) this.transaction = response;
						this.progress = false;
						this.etat_transaction = "success";
						this.dialog = false;
					})
					.catch(error => {
						this.progress = false;
						this.etat_transaction = "echec de la transaction";
						if (error.response != undefined) this.error_why = error.response.data.extras.result_codes.operations;
						else this.error_why = (error.message)
					});
			} catch (error) {
				this.etat_transaction = "Rejet de la transaction par le Wallet: " + error.toString().replace("TypeError: ", '');
				if (error.toString().replace("TypeError: ", '') == "Error: invalid version byte. expected 144, got undefined")
					this.etat_transaction = "Rejet par le Wallet: code secret vide ou code pin faux ou code de double vérification faux";
				this.error_data = error;
				//console.log(error)
				this.progress = false;
			}
		},


	},
	watch: {

		dialog: function () {
			if (!this.dialog) {
				this.$emit('close', this.etat_transaction)
				this.etat_transaction = undefined
				this.error_why = ""
				this.error_data = undefined
				this.transaction = undefined
			}
		}
	}
}
</script>

<style scoped>
</style>
